// this is to figure out what is connecting to what and how
/*
 * When connection is made we get a report like this from the app
 * here's the api in dev connenecting to various services
Connection fid-apd-rx:apd-dbp-elp-psd gql api(apd) development(local) to redis cache(rxd) at development(local)
Connection fid-apd-el:apd-dbp-elp-psd gql api(apd) development(local) to elastic(elp) at fid-home(gcp)
Connection fid-apd-ps:apd-dbp-elp-psd gql api(apd) development(local) to gcp pubsub(psd) at development(local)
Connection fid-apd-st:apd-dbp-elp-psd gql api(apd) development(local) to storage(stp) at fid-home(gcp)
Connection fid-apd-db:apd-dbp-elp-psd gql api(apd) development(local) to database(dbp) at cockroach cloud(cc)
Connection fid-apd-kg:apd-dbp-elp-psd gql api(apd) development(local) to knowledge graph api(kgp) at fid-home(gcp)
Connection fid-apd-ap:apd-dbp-elp-psd gql api(apd) development(local) to gql api(apd) at development(local)
 * 
 *  
 */
const getModes = ({source, target}) => {
  const {
    FIDDB,
    FIDPS,
    FIDEL,
    FIDAP,
    FIDVC,
    FIDST,
    FIDRX,
    FIDKG,
    FIDFB,
    FIDGT,
    FIDVZ,
    FIDVM,
    FIDVP,
    FIDSOURCE,
    VUE_APP_FIDDB,
    VUE_APP_FIDPS,
    VUE_APP_FIDEL,
    VUE_APP_FIDAP,
    VUE_APP_FIDVC,
    VUE_APP_FIDST,
    VUE_APP_FIDRX,
    VUE_APP_FIDKG,
    VUE_APP_FIDFB,
    VUE_APP_FIDGT,
    VUE_APP_FIDVZ,
    VUE_APP_FIDVM,
    VUE_APP_FIDVP,
    VUE_APP_FIDSOURCE,
    REACT_APP_FIDDB,
    REACT_APP_FIDPS,
    REACT_APP_FIDEL,
    REACT_APP_FIDAP,
    REACT_APP_FIDVC,
    REACT_APP_FIDST,
    REACT_APP_FIDRX,
    REACT_APP_FIDKG,
    REACT_APP_FIDFB,
    REACT_APP_FIDGT,
    REACT_APP_FIDVZ,
    REACT_APP_FIDVP,
    REACT_APP_FIDVM,
    REACT_APP_FIDSOURCE
  } = process.env;
  const env = {
    // defaults are as if running locally - except for when there's no local version
    // when envirnonment is fully built out, this would be changed to dev copies
    db: FIDDB || VUE_APP_FIDDB || REACT_APP_FIDDB || 'dbp',
    ps: FIDPS || VUE_APP_FIDPS || REACT_APP_FIDPS|| 'psd',
    el: FIDEL || VUE_APP_FIDEL || REACT_APP_FIDEL|| 'elp',
    ap: FIDAP || VUE_APP_FIDAP || REACT_APP_FIDAP|| 'apd',
    vc: FIDVC || VUE_APP_FIDVC || REACT_APP_FIDVC|| 'vcd',
    st: FIDST || VUE_APP_FIDST || REACT_APP_FIDST|| 'stp',
    rx: FIDRX || VUE_APP_FIDRX || REACT_APP_FIDRX|| 'rxd',
    kg: FIDKG || VUE_APP_FIDKG || REACT_APP_FIDKG|| 'kgp',
    fb: FIDFB || VUE_APP_FIDFB || REACT_APP_FIDFB || 'fbl',
    gt: FIDGT || VUE_APP_FIDGT || REACT_APP_FIDGT || 'gtd',
    vz: FIDVZ || VUE_APP_FIDVZ || REACT_APP_FIDVZ || 'vzd',
    vm: FIDVM || VUE_APP_FIDVM || REACT_APP_FIDVM || 'vmd',
    vp: FIDVP || VUE_APP_FIDVP || REACT_APP_FIDVP || 'vpd',
    source: source || FIDSOURCE || VUE_APP_FIDSOURCE || REACT_APP_FIDSOURCE|| 'apd',
    target
  }

  const connectionId = `fid-${env.source}-${env.target}:${env.ap}-${env.db}-${env.el}-${env.ps}`;
  const modes = {
    ...env,
    connectionId
  }

  return modes;
}
const modeTable = {
  db: {
    text: 'database'
  },
  ps: {
    text: 'gcp pubsub',
  },
  el: {
    text: 'elastic'
  },
  ap: {
    text: 'gql api'
  },
  st: {
    text: 'storage',
  },
  vc: {
    text: 'vue client'
  },
  rx: {
    text: 'redis cache'
  },
  kg: {
    text: 'knowledge graph api'
  },
  eb: {
    text: 'elastic bulk'
  },
  fb: {
    text: 'firebase auth'
  },
  vp: {
    text: 'vilabel processing'
  },
  vm: {
    text: 'vilabel manage pipeline'
  },
  vz: {
    text: 'vision callsheets'
  },
  gt: {
    text: 'gotenberg doc convertor'
  }
};
const serviceModes = {
  d: 'development',
  p: 'production',
  s: 'staging',
  x: 'proxy',
  l: 'legacy'
};

const platforms = {
  xm: { name: 'docker-compose', type: 'docker', key: 'm', redis: true },  // 'm' for coMpose
  xv: { name: 'docker-vm', type: 'docker', key: 'v', redis: true },         // 'v' for Vm
  xl: {
    name: 'fid-prod',
    type: 'gcp',
    key: 'xl',
    redis: true
  },
  xp: {
    name: 'fid-home',
    type: 'gcp',
    key: 'xp',
    redis: true,
    vpc: 'cockroach cloud'
  },
  xd: {
    name: 'development',
    type: 'local',
    key: 'xd',
    redis: false
  },
  xc: {
    name: 'cockroach cloud',
    type: 'cc',
    key: 'xc'
  },
  xf: {
    name: 'fid-sql',
    type: 'firebase',
    key: 'xf'
  }
};

// if something isnt is this list, but is requested - it'll bomb
const platformTables = {
  dbp: 'xc',
  dbl: 'xl',
  app: 'xp',
  apx: 'xp',
  apl: 'xl',
  apd: 'xd',
  ebd: 'xd',
  ebp: 'xp',
  elp: 'xp',
  eld: 'xd',
  vpp: 'xp',
  vmp: 'xp',
  vmd: 'xd',
  vpd: 'xd',
  vzd: 'xd',
  vzp: 'xp',
  psp: 'xp',
  psd: 'xd',
  psl: 'xl',
  vcd: 'xd',
  vcp: 'xp',
  stp: 'xp',
  stl: 'xl',
  rxp: 'xp',
  rxl: 'xl',
  rxd: 'xd',
  rxx: 'xd',
  rxu: 'xu',
  kgp: 'xp',
  kgl: 'xl',
  fbl: 'xf',
  gtp: 'xp',
  gtd: 'xd',
  // Docker Compose (use 'm' suffix in mode)
  dbm: 'xm',   // database on docker-compose
  elm: 'xm',   // elasticsearch on docker-compose
  rxm: 'xm',   // redis on docker-compose
  apm: 'xm',   // api on docker-compose
  vmm: 'xm',   // vmp on docker-compose
  vpm: 'xm',   // vpp on docker-compose
  // Docker VM (use 'v' suffix in mode)
  dbv: 'xv',
  elv: 'xv',
  rxv: 'xv',
  apv: 'xv'
}
const getPlatform = (mode) => {
  return platformTables[mode];
};

const getService = (item) => {
  // so for exampl dbp would be service db, service mode l
  return {
    item,
    name: item.slice(0, 2),
    mode: item.slice(2)
  }

}

const describeItem = (mode) => {
  const platform = platforms[getPlatform(mode)];
  if (!platform) {
    console.log('couldnt find platform for ', mode);
    throw new Error('mode with no platform');
  }
  const service = getService(mode);
  if (!service) {
    console.log('couldnt find service for ', mode);
    throw new Error('mode with no service');
  }
  return {
    mode,
    text: modeTable[service.name].text,
    serviceMode: service.mode,
    serviceName: service.name,
    serviceModeText: serviceModes[service.mode],
    platform,
    platformText: `${platform.name}(${platform.type})`,
  }
};
const checkConnection = ({modes, log, connectionType}) => {
  const description = describeModes ({modes, log});
  const {howToConnect} = description;
  const serviceName = howToConnect.target.serviceName;
  if (serviceName !== connectionType) {
    console.error(`trying to make a target connection to ${connectionType} using the wrong serviceName`, howToConnect.target);
    throw new Error(`invalid ${modeTable[connectionType]} connection serviceName`)
  }
  return {
    howToConnect,
    description,
    mode: howToConnect.target.mode,
    serviceName
  }
}

const describeModes = ({modes, log=false}) => {

  const description = Object.keys(modes)
    .filter(g=>g !== 'source' && g !=='target' && g!== 'connectionId')
    .map(f => describeItem(modes[f]));

  // get the source && target
  // the target will be one of the modes already defined
  const target =  description.find(f=>f.serviceName===modes.target);
  if (!target) {
    console.log('failed to find target', modes.target);
    throw new Error('unknown target'  + modes.target)
  }

  // the source needs a description too
  const source = describeItem ( modes.source )

  if (!source) {
    console.log('failed to find source', modes.source);
    throw new Error('invalid source'  + modes.source)
  }
  // add the to the description
  Array.prototype.push.apply(description, target,source);
  // if there's a vpc we can treat the
  const vpc = source.platform.vpc === target.platform.name
  const needIngress = (
    source.platform.name !== target.platform.name) && !vpc

  const  howToConnect = {
    connectionId: modes.connectionId,
    source,
    target,
    needIngress
  };

  const result = {
    modes,
    description,
    howToConnect
  }

  if (log) {
    const {source:s, target:t} = howToConnect;
    console.log(`Connection ${howToConnect.connectionId} ${s.text}(${s.mode}) ${s.platformText} to ${t.text}(${t.mode}) at ${t.platformText}`)
  }
  return result;
};

const generateConnection = ({ cobs, modes, log, connectionType }) => {

  // standard checking that we are connecting to the right thing
  const {
    howToConnect,
    mode
  } = checkConnection ({modes, log, connectionType});

  // connection object specific to this type
  const targetMode = cobs[mode];
  const host = howToConnect.needIngress ? targetMode.ingress.external : targetMode.ingress.internal;
  if (!host) {
    console.log('....failed to detect a host for',connectionType, howToConnect)
  }
  return {
    needIngress: howToConnect.needIngress,
    host,
    options: targetMode.options,
    howToConnect,
    targetMode
  }
}
const showEnvs = () => {
  const envs = Object.keys(process.env).filter(f => {
    return f.slice(0,3) === 'FID'
  })
  .map(f => {
    return {
      key: f,
      value: process.env[f]
    }
  })
  console.log('...detected env', envs)
  return envs
}
module.exports = {
  getModes,
  describeModes,
  getPlatform,
  checkConnection,
  generateConnection,
  showEnvs
}